/* Taeller op til 9.000.000.000 i jumbo-tekst, naar den kommer til syne. */
(function () {
  var TARGET = 9000000000;
  var LABEL = '9.000.000.000';
  var DURATION = 2600;

  function init() {
    var els = Array.prototype.filter.call(document.querySelectorAll('jumbo-text'), function (el) {
      return el.textContent.replace(/\s/g, '') === LABEL && !el.hasAttribute('data-counter');
    });
    els.forEach(setup);
  }

  function setup(el) {
    var chars = el.querySelectorAll('.jumbo-text-char-inner');
    if (chars.length !== 13) return;
    el.setAttribute('data-counter', '');
    el.style.fontVariantNumeric = 'tabular-nums';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var digitIdx = [0, 2, 3, 4, 6, 7, 8, 10, 11, 12];
    var dotIdx = { 1: 0, 5: 3, 9: 6 };

    function render(v) {
      var s = String(Math.floor(v)).padStart(10, '0');
      var fz = s.search(/[1-9]/);
      if (fz === -1) fz = 9;
      digitIdx.forEach(function (ci, i) {
        chars[ci].textContent = s.charAt(i);
        chars[ci].style.visibility = i < fz ? 'hidden' : 'visible';
      });
      Object.keys(dotIdx).forEach(function (ci) {
        chars[ci].style.visibility = fz <= dotIdx[ci] ? 'visible' : 'hidden';
      });
    }

    if (reduce) { render(TARGET); return; }
    render(0);

    var started = false;
    function run() {
      if (started) return;
      started = true;
      var t0 = null;
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / DURATION, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        render(p >= 1 ? TARGET : TARGET * eased);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { run(); io.disconnect(); }
        });
      }, { threshold: 0.4 });
      io.observe(el);
    } else {
      run();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
